/* eslint-disable import/prefer-default-export */
import * as Redux from 'redux'
import { reducer as reducerSummary } from './summary'
import { reducer as reducerDetails } from './details'
import type { State } from '@src/redux/configureStore'
import type { UnusedAccessReportReq } from '@src/endpoints/services/graphQueryMgr.service'
import { toastError, toastInfo } from '@src/utils/toast'
import { getUnusedAccessReport } from '@src/endpoints/custom.endpoints'
import uuidv4 from 'uuid/v4'
import { defaultHandleStatus } from '@src/endpoints/helpers'
import type { CreateReportReq } from '@src/endpoints/services/reportmanager.service'
import { ReportManager } from '@src/endpoints/services/reportmanager.service'

import {
  createReport,
  CreateReportReq as CreateReportReqParams
} from '@src/endpoints/openapis/saas-cam-reportmanager'

export const reducer = Redux.combineReducers({
  summary: reducerSummary,
  details: reducerDetails
})

export function onGetReport(params: UnusedAccessReportReq) {
  return (dispatch: any, getStore: () => State) => {
    toastInfo('Report generating started...')
    getUnusedAccessReport({
      req_hdr: {
        tid: uuidv4()
      },
      ...params
    })
      .then(res => defaultHandleStatus(res, null, true))
      .then(res => {
        const a = window.document.createElement('a')
        a.href = window.URL.createObjectURL(res.file)
        a.setAttribute('download', `report ${new Date()}.xlsx`)
        a.click()
      })
      .catch(ex => {
        toastError(`Failed to generating report...`)
        return ex
      })
  }
}

export function onCreateReport(params: CreateReportReq) {
  return (dispatch: any, getStore: () => State) => {
    ReportManager.CreateReport({
      params: {
        req_hdr: {
          tid: uuidv4()
        },
        ...params
      }
    })
      .then(res => {
        toastInfo('Report job has been passed to the queue')
        defaultHandleStatus(res, null, true)
      })
      .catch(ex => {
        toastError('Failed to generate report')
        return ex
      })
  }
}

export function onCreateReportV2(body: CreateReportReqParams) {
  return (dispatch: any, getStore: () => State) => {
    createReport({ body })
      .then(res => {
        toastInfo('Report job has been passed to the queue')
        defaultHandleStatus(res, null, true)
      })
      .catch(ex => {
        toastError('Failed to generate report')
        return ex
      })
  }
}
